import React from 'react';

import { Divider, Skeleton } from '@rbilabs/universal-components';
import { useBreakpointValue } from 'native-base';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

const SkeletonElement = () => (
  <Skeleton width={{ base: '$16', md: '$40' }} height="$5" rounded="full" />
);

export const MenuSectionTabsSkeleton = ({ style, ...props }: BoxProps) => {
  const paddingHorizontal = useBreakpointValue({
    base: spacing.$8,
    md: spacing.$32,
  });
  const paddingTop = useBreakpointValue({
    base: spacing.$2,
    md: spacing.$0,
  });

  return (
    <Box {...props} style={[styles.container, style]}>
      <Box
        style={[
          styles.tabs,
          {
            paddingHorizontal,
            paddingTop,
          },
        ]}
      >
        <SkeletonElement />
        <SkeletonElement />
        <SkeletonElement />
      </Box>
      <Divider thickness="2" />
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  tabs: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: spacing.$2,
  },
});
